export default __webpack_public_path__ + "static/media/ciliegie.ca5a9431.png";